import { render, staticRenderFns } from "./CardAgent.vue?vue&type=template&id=5b885e4a&scoped=true"
import script from "./CardAgent.vue?vue&type=script&lang=js"
export * from "./CardAgent.vue?vue&type=script&lang=js"
import style0 from "./CardAgent.vue?vue&type=style&index=0&id=5b885e4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b885e4a",
  null
  
)

export default component.exports